import { render, staticRenderFns } from "./sideTable.vue?vue&type=template&id=62cc7c16&scoped=true&"
import script from "./sideTable.vue?vue&type=script&lang=js&"
export * from "./sideTable.vue?vue&type=script&lang=js&"
import style0 from "./sideTable.vue?vue&type=style&index=0&id=62cc7c16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cc7c16",
  null
  
)

export default component.exports